import { render, staticRenderFns } from "./UploaderComponent.vue?vue&type=template&id=0240553e&scoped=true"
import script from "./UploaderComponent.vue?vue&type=script&lang=js"
export * from "./UploaderComponent.vue?vue&type=script&lang=js"
import style0 from "./UploaderComponent.vue?vue&type=style&index=0&id=0240553e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0240553e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0240553e')) {
      api.createRecord('0240553e', component.options)
    } else {
      api.reload('0240553e', component.options)
    }
    module.hot.accept("./UploaderComponent.vue?vue&type=template&id=0240553e&scoped=true", function () {
      api.rerender('0240553e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/default/UploaderComponent.vue"
export default component.exports